export default "__VITE_ASSET__5rIJO_YL__"